<form-control-container
  #container
  [control]="controlInstance"
  [class.readonly]="isReadonlyValue"
>
  <div label-extension>
    <ng-content select="[label-extension]"></ng-content>
  </div>

  <ng-container *ngIf="!isReadonlyValue">
    <input
      type="email"
      class="form-control"
      [id]="controlId"
      [attr.name]="inputName"
      [ngClass]="{ invalid: invalid }"
      [(ngModel)]="value"
      [disabled]="disabled"
      (focusout)="touch()"
      [autocomplete]="autocomplete ? 'on' : 'turn-off'"
      [attr.maxlength]="maxLength"
      [attr.tabindex]="tabindex"
      [attr.placeholder]="placeholder"
    />
  </ng-container>
  <ng-container *ngIf="isReadonlyValue">
    <span
      class="readonly-value"
      innerHTML="{{ value | emailToDisplayValue }}"
    ></span> </ng-container></form-control-container
>
